import { ACTION_APP_LOADED, ACTION_COMPLETED, ACTION_FAILED, ACTION_PENDING_APPROVAL, ACTION_SET_MODAL_STATE, ACTION_SET_THEME, ACTION_SET_USE_NEW_SDK } from "../reducers/constants";
import { AppIdentifier, Theme } from "../../types";
import { dispatchActionBasedOnAppIdentifier } from "../../utils";
import store from "../store";

export const openModal = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_SET_MODAL_STATE, { isAppActive: true })
}

export const closeModal = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_SET_MODAL_STATE, { isAppActive: false })
}

export const appLoaded = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_APP_LOADED, { isAppLoaded: true })
}

export const appPendingApproval = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_PENDING_APPROVAL, {})
}

export const appCompleted = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_COMPLETED, {})
}

export const appFailed = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_FAILED, {})
}

/**
 * setUseNewSdk dispatches into the `new-sdk-flags` slice directly (not
 * through `dispatchActionBasedOnAppIdentifier`), because that slice is keyed
 * by appIdentifier internally rather than having one reducer per app.
 */
export const setUseNewSdk = (appIdentifier: AppIdentifier, useNewSdk: boolean) => {
  store.dispatch({ type: ACTION_SET_USE_NEW_SDK, appIdentifier, useNewSdk })
}

/**
 * setTheme dispatches into the global `theme` slice. Forwarded to new
 * @zerohash-sdk/*-react components via AppContainer; legacy iframe and
 * Connect Auth paths ignore it.
 */
export const setTheme = (theme: Theme) => {
  store.dispatch({ type: ACTION_SET_THEME, theme })
}
